const butter = ($config) => {
  const Butter = require("buttercms");
  const lib = Butter($config.BUTTER_CMS_SECRET);
  return lib;
};

export { butter };
